import { render } from "./Select.vue?vue&type=template&id=0908d192&scoped=true&lang=pug"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=0908d192&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0908d192"

export default script